import { render, staticRenderFns } from "./Gestao.vue?vue&type=template&id=1f57652c"
import script from "./Gestao.vue?vue&type=script&lang=js"
export * from "./Gestao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports